/**
 * Article - Einzel-Ansicht Artikel für Neuanlegen Artikel oder Änderung / Einsicht Artikel-Daten
 * 
 *  - keine "Aufgaben" - diese in datamehr zu sehr an Geräte gebunden
 *    - für Artikel eigentlich nur "Bestellen" eine denkbare Aufgabe, hierfür anderer Mechanismus sinnvoll
 * 
 */

import { IonAlert, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCheckbox, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonMenuButton, IonPage, IonTitle, IonToolbar, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';
import Box from "@mui/material/Box";
import { DataGrid, deDE } from "@mui/x-data-grid";
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router';
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { ButtonAdd, ButtonCancelBack, ButtonInaktive , ButtonsSaveActions, defColumn, defColumnRenderCell, exportTableData, getDokumentDatei, ButtonPageHelp, PageHelp,readableFileSize, FieldHelpCE } from '../components/_HelperFunctions';
import { AppContext } from '../contexts/app_context';
import { useArticleDokumente, useArticlesGefahrstoffschulungenThemen , useGefahrstoffschulungen, useGefahrstoffschulungenThemen , useMitarbeiterListe } from '../components/_CustomHooks';

export function Article() {
  useIonViewDidEnter(
    () => {
      appViewSwitchChange(false);
    }
  );
  useIonViewWillLeave(
    () => {
      appArticlesFetchanewChange(true) ;
    }
  );
  const { appArticleDokumenteFetchanewChange, appBetriebeId, appArticleDokumente, appArticleDokumentIdChange , appArticlesGefahrstoffschulungenThemen , appArticlesGefahrstoffschulungenThemenFetchanewChange, appArticleIdChange , appArticlesFetchanewChange, appArticleId, appKundeId , appMitarbeiterListe , appGefahrstoffschulungIdChange ,appGefahrstoffschulungenThemen, appGefahrstoffschulungenThemenFetchanewChange , appGefahrstoffschulungen , appGefahrstoffschulungenFetchanewChange ,appGefahrstoffschulungNeuThemaChange , appUserIstEinweiser, appViewSwitchChange } = useContext(AppContext);
  const { lieferantenId } = useParams<{ lieferantenId: string; }>() ;
  const [pageHelpShow, setPageHelpShow] = useState(false);
  const [ fieldHelpCEShow , setFieldHelpCEShow ] = useState( false ) ;
  const screencastChannel = '' ;
  const history = useHistory();
  const [dataError, setDataError] = useState(false);
  const [ localArticleDokumente , localArticleDokumenteChange ] = useState( Array() ) ;
  const [ existInaktive , setExistInaktive ] = useState( false ) ;
  const [ showInaktive , setShowInaktive ] = useState( false ) ;
  /** Eintrag bearbeiten vs. Dokument herunterladen */
  const [dokumentToActOn, setDokumentToActOn] = useState('');
  /** State-Object (statt einzelner States) */
  const [article, setArticle] = useState(
    {
      id: appArticleId,
      aktiv: '',
      lieferanten_artikel_nr: '',
      basiseinheit: '',
      bestelleinheit: '',
      bezeichnung: '',
      inhalt_bestelleinheit: '',
      kategorie: '',
      lieferanten_id: '',
    }
  );
  /** Hilfsfunktion für Direktzugriff auf Property des State-Objects  */
  const articleSet = (prop: string, val: any) => {
    if (val === null) {
      val = '';
    }
    return Object.defineProperty(article, prop, { value: val });
  }
  /** Flag für evtl. nicht gesicherte Änderungen */
  const [ unsavedChanges, setUnsavedChanges ] = useState( Array() ) ;
  const noteUnsavedChanges = ( fieldName:string ) => {
    let myUnsavedChanges = unsavedChanges ;
    if( ! myUnsavedChanges.includes( fieldName ) ) {
      myUnsavedChanges.push( fieldName ) ;
      setUnsavedChanges( myUnsavedChanges ) ;
    }
    return true ;
  }
  /** checkboxSelectGefahrstoffschulungsThema */
  const [Gefahrstoffschulungsthemen, setGefahrstoffschulungsthemen] = useState( Array() )
  const [addAllThemen, setAddAllThemen] = useState(false);
  /** ! "lastAddedThema" auch als Trigger, damit Ionic re-rendert */
  const [lastAddedThema, setLastAddedThema] = useState('');
  /** ! "anzahlThemen" auch als Trigger, damit Ionic re-rendert */
  const [anzahlThemen, setAnzahlThemen] = useState(0);
  /** Auf einen konkreten / internen Artikel bezogene Gefahrstoffschulungen */
  const [Gefahrstoffschulungen, setGefahrstoffschulungen] = useState( Array() )
  const [pageSize, setPageSize] = useState(10);
  useEffect(
    () => {
      if (appArticleId !== 'neu') {
        appArticleDokumenteFetchanewChange(true);
        appArticlesGefahrstoffschulungenThemenFetchanewChange(true);
      }
    },
    [appArticleId]
  );
  useGefahrstoffschulungenThemen();
  const getDataArticle = () => {
    if (appArticleId === 'neu') {
      setArticle( articleSet('id', 'neu'));
      setArticle(articleSet('aktiv', 'aktiv'));
      setArticle(articleSet('lieferanten_artikel_nr', ''));
      setArticle(articleSet('basiseinheit', ''));
      setArticle(articleSet('bestelleinheit', ''));
      setArticle(articleSet('bezeichnung', ''));
      setArticle(articleSet('inhalt_bestelleinheit', ''));
      setArticle(articleSet('kategorie', ''));
      setArticle(articleSet('lieferanten_id', lieferantenId ))
    } else {
      const api = axios.create({
        baseURL: `https://datamehr-backend.saint-online.de/api/articles/get_article.php?my_table=artikel&article_id=` + appArticleId,
        headers: {
          'Accept': 'application/json',
          Authorization: `Bearer ${window.localStorage.getItem('jwt')}`,
        },
      });
      api.get("")
        .then(
          (res) => {
            setDataError(false);
            let data = res.data;
            data.forEach(
              (entry: any) => {
                if (entry.id === appArticleId) {
                  setArticle(articleSet('id', entry.id));
                  setArticle(articleSet('aktiv', entry.aktiv));
                  setArticle(articleSet('lieferanten_artikel_nr', entry.lieferanten_artikel_nr));
                  setArticle(articleSet('basiseinheit', entry.basiseinheit));
                  setArticle(articleSet('bestelleinheit', entry.bestelleinheit));
                  setArticle(articleSet('bezeichnung', entry.bezeichnung));
                  setArticle(articleSet('inhalt_bestelleinheit', entry.inhalt_bestelleinheit));
                  setArticle(articleSet('kategorie', entry.kategorie));
                  setArticle(articleSet('lieferanten_id', entry.lieferanten_id))
                }
              }
            )
          }
        )
        .catch(
          () => setDataError(true)
        );
    }
  }
  useEffect(
    () =>
      {
        getDataArticle()
        appGefahrstoffschulungenFetchanewChange( true )
      }
    ,
    [appBetriebeId, appArticleId]
  );
  useEffect(
    () => {
      let myGefahrstoffschulungsthemen = Array() ;
      appArticlesGefahrstoffschulungenThemen
        .forEach(
          (entry: any) => {
            if( entry.artikel === appArticleId ) {
              if( entry.thema !== '' ) {
                myGefahrstoffschulungsthemen.push( entry.thema ) ;
              }
            }
          }
        )
        setGefahrstoffschulungsthemen( myGefahrstoffschulungsthemen );
        setAnzahlThemen(myGefahrstoffschulungsthemen.length ) ;  
      },
    [ appArticlesGefahrstoffschulungenThemen , appArticleId ]
  );
  useEffect(
    () => {
      let myGefahrstoffschulungen = appGefahrstoffschulungen
           .filter(
            ( entry:any ) =>
              {
                if(
                  appGefahrstoffschulungenThemen
                    .findIndex(
                      ( thema:any ) => {
                        if( thema.SchulungenId === entry.GefahrstoffschulungenThema ) {
                          if( thema.SchulungenAktiv === 'aktiv' ) {
                            return true
                          }
                          return false ;
                        }
                        return false ;
                      }
                    ) > -1
                )
                  { 
                    return true ;
                  }
                  return false ;
                }
           )
        .filter(
          ( entry:any ) =>
            { 
              return Gefahrstoffschulungsthemen.includes( entry.GefahrstoffschulungenThema )
            }
        )
      setGefahrstoffschulungen( myGefahrstoffschulungen ) ;
      },
    [ appGefahrstoffschulungen , appGefahrstoffschulungenThemen , Gefahrstoffschulungsthemen ]
  );
  useArticleDokumente();

  const handleInaktive = () =>
    {
      if( showInaktive ) {
        localArticleDokumenteChange( appArticleDokumente )
      }
      else {
        localArticleDokumenteChange(
          appArticleDokumente
            .filter(
              ( entry:any ) => entry.DokumenteAktiv === 'aktiv'
            )        
        )
      }
    }

  useEffect(
    () => {
      if( appArticleDokumente
          .findIndex(
            ( entry:any ) => entry.DokumenteAktiv === 'inaktiv'
          ) > -1
      )
        {
          setExistInaktive( true )
        }
      else
        {
          setExistInaktive( false )
        }
      handleInaktive() ;
    } ,
    [ appArticleDokumente ]
  )
  
  useEffect(
    () => {
      handleInaktive() ;
    } ,
    [ showInaktive ]
  )
  
  useArticlesGefahrstoffschulungenThemen() ;
  useMitarbeiterListe();
  useGefahrstoffschulungen();
  async function sendChangesArticle() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append('Authorization', `Bearer ${window.localStorage.getItem('jwt')}`);
    var raw = JSON.stringify({
      id: article.id,
      aktiv: article.aktiv || 'aktiv',
      lieferanten_artikel_nr: article.lieferanten_artikel_nr || '',
      basiseinheit: article.basiseinheit || '',
      bestelleinheit: article.bestelleinheit || '',
      bezeichnung: article.bezeichnung || '(k.A.)',
      inhalt_bestelleinheit: article.inhalt_bestelleinheit || '',
      kategorie: article.kategorie || '',
      lieferanten_id: article.lieferanten_id || '',
      betriebeId: appBetriebeId
    });
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
    };
    fetch('https://datamehr-backend.saint-online.de/api/articles/set_article.php?my_table=artikel', requestOptions)
    .then( response => response.json() )
    .then(
       json =>
        {
          if( json.entryId > 0 ) {
            return json.entryId
          }
          else {
            return appArticleId
          }
        }
       )
    .then(
       ( myArticleId ) =>
        {
          saveChangesGefahrstoffschulungsthemen( myArticleId )
          return myArticleId ;
        }
       )
    .then(
      ( myArticleId ) =>
        {
          appArticleIdChange( myArticleId ) ;
          setArticle( articleSet( 'id' , myArticleId ) );
        }
      )
  }
  async function saveChangesGefahrstoffschulungsthemen( myArticle:any ) {
    /** ! Möglich: Sowohl neue Zuordnung dazu wie bestehende löschen */
    let raw = '';
    /** Mutable Gefahrstoffschulungsthemen */
      let chkGefahrstoffschulungsthemen = Gefahrstoffschulungsthemen ;
    /** Existierende Artikel-Themen-Paare abgleichen */
      appArticlesGefahrstoffschulungenThemen
        .filter(
          ( entry:any) =>
            entry.artikel === appArticleId
        )
        .forEach(
          ( entry:any) =>
            {
              /** vorhandenen Eintrag löschen oder beibehalten */
                if ( ! chkGefahrstoffschulungsthemen.includes( entry.thema ) ) {
                  /** vorhandener Eintrag nicht in chkGefahrstoffschulungsthemen => ThemaId löschen
                   *  - Backend entscheidet, ob der Eintrag insgesamt gelöscht oder re-used wird
                   */
                    /** bereits "leere" Einträge nicht nochmals schreiben */
                      if ( entry.thema !== '' ) {
                        raw = JSON.stringify({
                          id: entry.id ,
                          kunde: appKundeId ,
                          betrieb: appBetriebeId ,
                          artikel: myArticle ,
                          thema: ''
                          });
                        sendChangesGefahrstoffschulungsThema(raw) ;
                      }
                }
                else {
                  let existingThema = entry.thema ;
                  /** vorhandenen Eintrag von chkGefahrstoffschulungsthemen nehmen */
                    chkGefahrstoffschulungsthemen = chkGefahrstoffschulungsthemen
                      .filter(
                        ( entry:any ) => entry !== existingThema
                      )
                }
              }
        )
      /** Etwaige verbleibende neue Artikel-Themen-Paare schreiben */
        chkGefahrstoffschulungsthemen
          .forEach(
            ( entry:any ) =>
              {
                raw = JSON.stringify(
                  {
                    kunde: appKundeId ,
                    betrieb: appBetriebeId ,
                    artikel: myArticle ,
                    thema: entry
                  }
                );
                sendChangesGefahrstoffschulungsThema(raw);
                appGefahrstoffschulungenFetchanewChange( true ) ;
              }
          )
  }
  async function sendChangesGefahrstoffschulungsThema(JSON: any) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append('Authorization', `Bearer ${window.localStorage.getItem('jwt')}`);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON,
    };
    await fetch('https://datamehr-backend.saint-online.de/api/themen/set_articles_themen.php', requestOptions)
    appArticlesGefahrstoffschulungenThemenFetchanewChange( true ) ;
  }
  const form = {
    lieferanten_artikel_nr: (e: any) => setArticle(articleSet('lieferanten_artikel_nr', e.target.value)),
    aktiv: (e: any) => {
      setArticle(
        articleSet(
          'aktiv',
          e.detail.checked
          ? 
            'aktiv'
          :
            'inaktiv'
        )
      )
    },
    basiseinheit: (e: any) => setArticle(articleSet('basiseinheit', e.target.value)),
    bestelleinheit: (e: any) => setArticle(articleSet('bestelleinheit', e.target.value)),
    bezeichnung: (e: any) => setArticle(articleSet('bezeichnung', e.target.value)),
    inhalt_bestelleinheit: (e: any) => setArticle(articleSet('inhalt_bestelleinheit', e.target.value)),
    kategorie: (e: any) => setArticle(articleSet('kategorie', e.target.value)),
    standort: (e: any) => setArticle(articleSet('standort', e.target.value)),
  }
  function onValueThemaListe(schulungenId: any) {
    let myGefahrstoffschulungsthemen = Gefahrstoffschulungsthemen;
    if (schulungenId === 'alle') {
      myGefahrstoffschulungsthemen = [];
      setLastAddedThema('');
    } else {
      myGefahrstoffschulungsthemen = myGefahrstoffschulungsthemen.filter((entry: any) => entry !== schulungenId);
    }
    setGefahrstoffschulungsthemen(myGefahrstoffschulungsthemen);
    setAnzahlThemen(myGefahrstoffschulungsthemen.length);
    setAddAllThemen(false);
  }
  function onValueThemaDazu(schulungenId: any, schulungenTitel: string) {
    let myGefahrstoffschulungsthemen = Gefahrstoffschulungsthemen;
    if (schulungenId === 'alle') {
      setAddAllThemen(true);
    } else {
      /** vermutlich wg. State / Rerender wird die Anweisung hier mehrfach durchlaufen, deshalb Check auf "schon gesetzt" */
      if (!myGefahrstoffschulungsthemen.includes(schulungenId)) {
        myGefahrstoffschulungsthemen.push(schulungenId);
      }
    }
    setGefahrstoffschulungsthemen(myGefahrstoffschulungsthemen);
    setAnzahlThemen(myGefahrstoffschulungsthemen.length);
  }
  /** Komplex und / oder für Reuse */
  const checkboxSelectGefahrstoffschulungsThema = () => {
    if (appUserIstEinweiser === 'ja' ) {
      if ( appArticleId === 'neu' ) {
        return (
            <IonItem>
              <IonLabel position="stacked">Gefahrstoffschulung (Thema)</IonLabel>
              <p>
                Sie müssen eine neuen Artikel zuerst <b>anlegen</b>, bevor Sie Gefahrstoffschulungsthemen hinzufügen können
              </p>
            </IonItem>
        )
      }
      else {
        return (
          <>
            <IonItem>
              <IonLabel position="stacked">Gefahrstoffschulung (Thema) ({anzahlThemen} gewählt)</IonLabel>
              <div style={{ height: '200px', overflowY: 'scroll', width: '100%' }}>
                {
                  (Gefahrstoffschulungsthemen.toString() !== '')
                    ?
                    <IonItem lines="none" className='item'>
                      <IonLabel slot="">alle entfernen</IonLabel>
                      <IonCheckbox slot="start" key='alle' checked={false} onIonChange={() => noteUnsavedChanges( 'Gefahrstoffschulung (Thema)' ) && onValueThemaListe('alle')} />
                    </IonItem>
                    :
                    ''
                }
                {
                  appGefahrstoffschulungenThemen
                    .filter(
                      (entry: any) => Gefahrstoffschulungsthemen.includes(entry.SchulungenId)
                    )
                    .filter(
                      (entry: any) => entry.SchulungenAktiv !== 'inaktiv'
                    )
                    .map(
                      (entry: any) => {
                        /* !!! Für "neu" inaktive Gefahrstoffschulungsthemen ausblenden, für existierende Gefahrstoffschulungen als inaktiv markieren */
                        let disabled = false;
                        let disabledNote = '';
                        if (entry.SchulungenAktiv === 'inaktiv') {
                          disabled = true;
                          disabledNote = ' (inaktiv )';
                        }
                        return (
                          <IonItem lines="none" className='item'>
                            <IonLabel slot="">{entry.SchulungenTitel + disabledNote}</IonLabel>
                            <IonCheckbox slot="start" key={entry.SchulungenId + '_onList'} disabled={disabled} checked={anzahlThemen > 0 ? true : false} onIonChange={() => noteUnsavedChanges( 'Gefahrstoffschulung (Thema)' ) && onValueThemaListe(entry.SchulungenId)} />
                          </IonItem>
                        )
                      }
                    )
                }
              </div>
            </IonItem>
            <IonItem className='item'>
              <IonLabel position="stacked">Thema hinzufügen {lastAddedThema !== '' ? '(zuletzt hinzugefügt:' + lastAddedThema + ')' : ''}</IonLabel>
              <div style={{ height: '200px', overflowY: 'scroll', width: '100%' }}>
                {/* {
                            ! addAllThemen
                              ?
                                <IonItem lines="none" className='item'>
                                  <IonLabel slot="">alle hinzufügen</IonLabel>
                                  <IonCheckbox slot="start" key = 'alle' checked={ false } onIonChange={() => onValueThemaDazu( 'alle' , '' ) } />
                                </IonItem>
                              :
                                ''
                          } */}
                {
                  appGefahrstoffschulungenThemen
                    .filter(
                      (entry: any) => !Gefahrstoffschulungsthemen.includes(entry.SchulungenId)
                    )
                    .filter(
                      (entry: any) => entry.SchulungenAktiv !== 'inaktiv'
                    )
                    .map(
                      (entry: any) => {
                        /* !!! Für "neu" inaktive Gefahrstoffschulungsthemen ausblenden, für existierende Gefahrstoffschulungen als inaktiv markieren */
                        let disabled = false;
                        let disabledNote = '';
                        if (entry.SchulungenAktiv === 'inaktiv') {
                          disabled = true;
                          disabledNote = ' (inaktiv )';
                        }
                        return (
                          <IonItem lines="none" className='item'>
                            <IonLabel slot="">{entry.SchulungenTitel + disabledNote}</IonLabel>
                            <IonCheckbox slot="start" key={entry.SchulungenId + '_offList'} disabled={disabled} checked={addAllThemen} onIonChange={() => noteUnsavedChanges( 'Gefahrstoffschulung (Thema)' ) && onValueThemaDazu(entry.SchulungenId, entry.SchulungenTitel)} />
                          </IonItem>
                        )
                      }
                    )
                }
              </div>
            </IonItem>
          </>
        )
      }
    }
  }
  return (
    <IonPage>
      <PageHelp page='Artikel' state={pageHelpShow} set={setPageHelpShow} >
        <p>
          Auf dieser Seite können Sie Vorgabeeinstellungen für Artikel erstellen und bearbeiten. Die Vorgabeeinstellungen werden in den tatsächlichen Einträgen im Menü "Artikel" wirksam.
        </p>
      </PageHelp>
      <FieldHelpCE state = { fieldHelpCEShow } set = { setFieldHelpCEShow } />
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle slot=""  >
            {/* Voreinstellungen Artikel { article.bezeichnung === '' ? 'neu' : article.bezeichnung } */}
            Artikel { article.bezeichnung === '' ? 'neu' : article.bezeichnung }
          </IonTitle>
          <ButtonPageHelp page = { screencastChannel } state = { pageHelpShow } set = { setPageHelpShow } />
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {
          dataError
            ?
            (
              <IonCard>
                <IonCardContent>
                  Fehler: keine Daten
                </IonCardContent>
                <ButtonCancelBack
                  label = 'Abbrechen'
                  myExec =
                    {
                      () =>
                        {
                        }
                    }
                />
              </IonCard>
            )
            :
            <>
                    <IonCard>
                      <IonCardContent>
                        <IonItem className='item'>
                          <IonLabel slot="">aktiv</IonLabel>
                          <IonCheckbox slot="start" checked={ article.aktiv === 'aktiv' ? true : false } onIonChange={(e) => form.aktiv(e)} />
                        </IonItem>
                        <IonItem className='item'>
                          <IonLabel position="stacked">Artikelnummer</IonLabel>
                          <IonInput required value={article.lieferanten_artikel_nr} onIonChange={(e) => form.lieferanten_artikel_nr(e)} />
                        </IonItem>
                        <IonItem className='item'>
                          <IonLabel position="stacked">Kategorie</IonLabel>
                          <IonInput required value={article.kategorie} onIonChange={(e) => form.kategorie(e)} />
                        </IonItem>
                        <IonItem className='item'>
                          <IonLabel position="stacked">Bezeichnung</IonLabel>
                          <IonInput required value={article.bezeichnung} onIonChange={(e) => form.bezeichnung(e)} />
                        </IonItem>
                        <IonItem className='item'>
                          <IonLabel position="stacked">Bestelleinheit</IonLabel>
                          <IonInput required value={article.bestelleinheit} onIonChange={(e) => form.bestelleinheit(e)} />
                        </IonItem>
                        <IonItem className='item'>
                          <IonLabel position="stacked">Inhalt</IonLabel>
                          <IonInput required value={article.inhalt_bestelleinheit} onIonChange={(e) => form.inhalt_bestelleinheit(e)} />
                        </IonItem>
                        <IonItem className='item'>
                          <IonLabel position="stacked">Basiseinheit</IonLabel>
                          <IonInput required value={article.basiseinheit} onIonChange={(e) => form.basiseinheit(e)} />
                        </IonItem>
                        {
                          checkboxSelectGefahrstoffschulungsThema()
                        }
                        {/* !? für neue Artikel einen "ButtonSaveClose" = kein "Speichern" ohne "Schließen" */}
                        <ButtonsSaveActions
                          myExec={
                            () =>
                              {
                                setUnsavedChanges( Array() ) ;
                                sendChangesArticle();
                               }
                          }
                        />
                        <ButtonCancelBack
                          label='Abbrechen'
                          myExec =
                            {
                              () =>
                                {
                                  if( unsavedChanges.toString() !== '' ) {
                                    if(
                                      ! window.confirm(
                                        '\n'
                                        + 'In den folgenden Feldern liegen nicht gespeicherte Änderungen vor:'
                                        + '\n\n' + unsavedChanges.join( ', ' )
                                        + '\n\n'
                                      )
                                    )
                                      {
                                        return false ;
                                      }
                                  }
                                }
                            }
                        />
                      </IonCardContent>
                    </IonCard>
                  </>
              }
              {
                appArticleId === "neu"
                  ? 
                    <>
                      <IonCard class="Dokumente">
                        <IonCardHeader>
                          <IonCardTitle>Dokumente</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                          Sie müssen einen neuen Artikel zuerst <b>anlegen</b>, bevor Sie Dokumente hinzufügen können
                        </IonCardContent>
                      </IonCard>
                    </>
                  : (
                    <>
                      {/* !! hier AN SICH / LANGFRISTIG keine "Gefahrstoffschulungen", da sich diese auf einen konkreten Betrieb mit tatsächlichen Artikeln beziehen (hier Voreinstellungen für Artikel)  */}
                      {
                        appUserIstEinweiser === 'ja'
                          ?
                          <IonCard class="Gefahrstoffschulungen">
                            <IonCardHeader>
                              <IonCardTitle>Gefahrstoffschulungen</IonCardTitle>
                            </IonCardHeader>
                            {
                              Gefahrstoffschulungen.length > 0
                                ?
                                <Box width="100vh"
                                  sx={{
                                    height: 300,
                                    width: 1,
                                    "& .super-app-theme--header": {
                                      backgroundColor: "rgb(211,211,211)",
                                    },
                                  }}
                                >
                                  <DataGrid
                                    disableVirtualization
                                    initialState={{
                                      sorting: {
                                        sortModel: [{ field: 'GefahrstoffschulungenTermin', sort: 'asc' }],
                                      },
                                    }}
                                    getRowId={(row) => row.GefahrstoffschulungenId}
                                    rows={Gefahrstoffschulungen}
                                    columns={
                                      [
                                        defColumn("GefahrstoffschulungenId", "Id", 0),
                                        defColumn("GefahrstoffschulungenStatus", "Status", 90, 0),
                                        /** "GefahrstoffschulungenMitarbeiterId"
                                        *    - ! genau so in verschiedenen Komponenten an verschiedenen Stellen
                                        *        => wg. lokaler Daten-States statt useContext vorerst via
                                        *           Copy & Paste zu handlen
                                        */
                                        defColumnRenderCell(
                                          defColumn("GefahrstoffschulungenTermin", "Termin", 100, 0),
                                          (data: any) => data.row.GefahrstoffschulungenTermin === '0000-00-00'
                                            ?
                                            '(offen)'
                                            :
                                            new Date(data.row.GefahrstoffschulungenTermin).toLocaleDateString()
                                        ),
                                        defColumn('GefahrstoffschulungenDozent', 'Dozent/in', 140, 0),
                                        defColumnRenderCell(
                                          defColumn('GefahrstoffschulungenThema', 'Thema', 300, 1, 300),
                                          (params: any) => {
                                            if (params.row.GefahrstoffschulungenThema) {
                                              let matchesGefahrstoffschulungenTitel = appGefahrstoffschulungenThemen
                                                .find(
                                                  (entry: any) => entry.SchulungenId === params.row.GefahrstoffschulungenThema
                                                )
                                              if (matchesGefahrstoffschulungenTitel) {
                                                return matchesGefahrstoffschulungenTitel.SchulungenTitel;
                                              }
                                            }
                                          }
                                        ),
                                        /** "GefahrstoffschulungenMitarbeiterId"
                                         *    - ! genau so in verschiedenen Komponenten an verschiedenen Stellen
                                         *        => wg. lokaler Daten-States statt useContext vorerst via
                                         *           Copy & Paste zu handlen
                                         */
                                        defColumnRenderCell(
                                          defColumn("GefahrstoffschulungenMitarbeiterId", "Teilnehmer"),
                                          (params: any) => {
                                            if (params.row.GefahrstoffschulungenMitarbeiterId) {
                                              let matchesMitarbeiterDB = appMitarbeiterListe
                                                .filter(
                                                  ({ MitarbeiterId }: { MitarbeiterId: any }) =>
                                                    /** Präfigierung mit ',' für z.B. "89" vs. "189" (",89" vs. ",189")
                                                     *  - in Klammern wg. "( ',' xy).includes" vs. "',' + (xy.includes)"  
                                                     */
                                                    (',' + params.row.GefahrstoffschulungenMitarbeiterId)
                                                      .includes(',' + MitarbeiterId)
                                                )
                                                .map(
                                                  ({ MitarbeiterNachname }: { MitarbeiterNachname: any }) => MitarbeiterNachname
                                                )
                                              if (matchesMitarbeiterDB) {
                                                return matchesMitarbeiterDB.toString();
                                              }
                                            }
                                          }
                                        )
                                      ]
                                    }
                                    pageSize={pageSize}
                                    rowsPerPageOptions={[10, 50, 100]}
                                    disableSelectionOnClick
                                    onCellClick={
                                      (e: any) => {
                                        appViewSwitchChange(true);
                                        appGefahrstoffschulungIdChange(e.id);
                                        history.push('/gefahrstoffschulung/' + e.id )
                                      }
                                    }
                                    sortingOrder={["desc", "asc"]}
                                    onPageSizeChange={(newPage) => setPageSize(newPage)}
                                    pagination
                                    localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                                  />
                                </Box>
                                :
                                ""
                            }
                            <ButtonAdd
                              myExec = 
                                {
                                  () =>
                                    {
                                      if( unsavedChanges.includes( 'Gefahrstoffschulung (Thema)' ) ) {
                                        alert(
                                          'Die Artikel-Eigenschaft "Gefahrstoffschulung (Thema)" wurde geändert. Das Planen von neuen Gefahrstoffschulungen ist erst nach Speichern der Änderungen möglich.\n'
                                        ) ;
                                        return false ;
                                      }
                                      if( Gefahrstoffschulungsthemen.toString() === '' ) {
                                        alert(
                                          'Sie müssen dem Artikel ein Thema für Gefahrstoffschulungen zuordnen, damit neue Gefahrstoffschulungen geplant werden können.'
                                        ) ;
                                        return false ;
                                      }
                                      appGefahrstoffschulungNeuThemaChange( Gefahrstoffschulungsthemen[ 0 ] ) ;
                                      appGefahrstoffschulungIdChange('neu') ;
                                      appGefahrstoffschulungenThemenFetchanewChange( true ) ;
                                    }
                                }
                              routeUrl={'/gefahrstoffschulung/neu'}
                            />
                            {
                              Gefahrstoffschulungen.length > 0
                                ?
                                <IonButton onClick={() => exportTableData(Gefahrstoffschulungen, 'Gefahrstoffschulungen Artikel ' + appArticleId)}>Exportieren</IonButton>
                                :
                                ''
                            }
                          </IonCard>
                          :
                          ''
                      }                      
                      <IonCard class="Dokumente">
                        <IonAlert
                          isOpen={dokumentToActOn ? true : false}
                          backdropDismiss={true}
                          header='Gewählte Datei ...'
                          message=''
                          buttons={
                            [
                              {
                                text: 'Herunterladen',
                                handler: () => {
                                  getDokumentDatei(dokumentToActOn);
                                  setDokumentToActOn('');
                                }
                              },
                              {
                                text: 'Listeneintrag bearbeiten',
                                handler: () => {
                                  appViewSwitchChange( true ) ;
                                  appArticleDokumentIdChange( dokumentToActOn ) ;
                                  history.push('/dokument-article/' + dokumentToActOn + '/' + appArticleId)
                                  setDokumentToActOn('');
                                }
                              },
                              {
                                text: 'Abbrechen',
                                handler: () => {
                                  setDokumentToActOn('');
                                }
                              }
                            ]
                          }
                        />
                        <IonCardHeader>
                          <IonCardTitle>Dokumente</IonCardTitle>
                        </IonCardHeader>
                        {
                          appArticleDokumente.length > 0
                            ?
                            <Box width="100vh"
                              sx={{
                                height: 300,
                                width: 1,
                                "& .super-app-theme--header": {
                                  backgroundColor: "rgb(211,211,211)",
                                },
                              }}
                            >
                              <DataGrid
                                disableVirtualization
                                initialState={{
                                  sorting: {
                                    sortModel: [{ field: 'DokumenteDateidatum', sort: 'desc' }],
                                  },
                                }}
                                getRowId={(row) => row.DokumenteId}
                                getRowClassName =
                                {
                                  ( data:any ) => data.row.DokumenteAktiv === 'inaktiv' ? 'eintrag_inaktiv' : ''
                                }
                                rows = { localArticleDokumente }
                                columns={
                                  [
                                    defColumn( "DokumenteId" , "Id" , 0 ) ,
                                    defColumnRenderCell(
                                      defColumn( "DokumenteDateidatum" , "Datum" , 150 , 0 ) ,
                                      ( data:any ) =>
                                        new Date( data.row.DokumenteDateidatum ).toLocaleString()
                                    ) ,
                                    defColumn( "DokumenteThema" , "Bezeichnung" , 300 ) ,
                                    defColumnRenderCell(
                                      defColumn( "DokumenteDateigroesse" , "Größe" , 80 , 1 , 80 ) ,
                                      ( data:any ) =>
                                        readableFileSize( parseInt( data.row.DokumenteDateigroesse , 10 ) )
                                    ) ,
                                    defColumn( "DokumenteDateiname" , "Dateiname" , 300 )
                                  ]
                                }
                                pageSize={pageSize}
                                rowsPerPageOptions={[10, 50, 100]}
                                disableSelectionOnClick
                                onCellClick=
                                {
                                  (e: any) => {
                                    /** Browser / Web vs. App nativ */
                                    if (navigator) {
                                      setDokumentToActOn(e.id);
                                    } else {
                                      appArticleDokumentIdChange( e.id ) ;
                                      appViewSwitchChange(true);
                                      history.push('/dokument-article/' + e.id + '/' + appArticleId)
                                    }
                                  }
                                }
                                sortingOrder={["desc", "asc"]}
                                onPageSizeChange={(newPage) => setPageSize(newPage)}
                                pagination
                                localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                              />
                            </Box>
                            :
                            ""
                        }
                        <ButtonInaktive
                          disabled = { existInaktive ? false : true }
                          myExec = {
                            () =>
                              {
                                setShowInaktive( showInaktive ? false : true )
                              }
                          }
                          label = { showInaktive ? 'Inaktive ausblenden' : 'Inaktive anzeigen' }
                        />
                        <ButtonAdd
                          myExec={() => { appArticleDokumentIdChange( 'neu') ; }}
                          routeUrl={'/dokument-article/neu/' + appArticleId}
                        />
                        {
                          appArticleDokumente.length > 0
                            ?
                            <IonButton onClick={() => exportTableData(appArticleDokumente, 'Dokumente Artikel ' + appArticleId)}>Exportieren</IonButton>
                            :
                            ''
                        }
                      </IonCard>
                    </>
                  )
              }
      </IonContent>
    </IonPage>
  );
};

